import { useSyncExternalStore } from 'react';
import {
  getImageViewTransform,
  subscribeImageViewTransform,
  type ImageViewTransform,
} from '../helpers/imageViewTransformStore';

/**
 * Subscribes to the shared image view transform published by ProgressiveImageWeb.
 * Returns the current `{ zoom, panX, panY }` for the given documentId.
 */
export const useImageViewTransform = (documentId: number | null | undefined): ImageViewTransform =>
  useSyncExternalStore(
    subscribeImageViewTransform,
    () => getImageViewTransform(documentId),
    () => getImageViewTransform(documentId)
  );
